import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const TempoTraveller = () => {
  return (
    <>
      <section
        className="page-title"
        style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Tempo Traveller Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>Luxury Tempo Traveller by eTravo</h1>

        <p style={styles.paragraph}>
          eTravo offers premium Tempo Traveller rental services tailored to meet your group travel needs.
          Whether you're planning a family trip, corporate outing, wedding event, or pilgrimage tour, our
          fleet of well-maintained and spacious vehicles ensures comfort and safety on every journey.
        </p>

        <h2 style={styles.subHeader}>Available Variants:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>9-Seater:</strong> Ideal for family travel</li>
          <li style={styles.listItem}><strong>12-Seater:</strong> Best for small group tours</li>
          <li style={styles.listItem}><strong>17-Seater:</strong> Perfect for larger groups and events</li>
        </ul>

        <h2 style={styles.subHeader}>Key Features:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Fully Air-Conditioned Interior</li>
          <li style={styles.listItem}>Reclining Pushback Seats</li>
          <li style={styles.listItem}>LED TV & Music System</li>
          <li style={styles.listItem}>Ample Luggage Space</li>
          <li style={styles.listItem}>Onboard Charging Ports</li>
          <li style={styles.listItem}>Experienced and Verified Drivers</li>
        </ul>

        <h2 style={styles.subHeader}>Why Choose eTravo?</h2>
        <p style={styles.paragraph}>
          At <strong>eTravo</strong>, we believe in making travel easy, affordable, and luxurious. With a strong
          commitment to customer satisfaction, we ensure that every ride with us is comfortable and safe.
          Our Tempo Travellers are regularly sanitized, GPS-enabled, and driven by courteous professionals.
        </p>

        <p style={styles.paragraph}>
          With years of experience in the travel industry, eTravo has built a reputation for reliable
          service, transparent pricing, and tailored travel solutions for individuals, families, and corporates.
        </p>

        <h2 style={styles.subHeader}>Service Highlights:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>24/7 Booking Support</li>
          <li style={styles.listItem}>Flexible Pickup & Drop Locations</li>
          <li style={styles.listItem}>Pan-India Operations</li>
          <li style={styles.listItem}>Instant Booking Confirmation</li>
        </ul>

       

        <h2 style={styles.subHeader}>Book with eTravo Today!</h2>
        <p style={styles.paragraph}>
          Whether it's a weekend getaway or a long-distance journey, eTravo is your trusted travel companion. 
          Experience the convenience of seamless group travel — call us or book online today!
        </p>
      </div>
    </>
  );
};

export default TempoTraveller;
